import React from 'react';

import { Sheet } from '@pkg/components';
import YatRedirectForm from '@pkg/components/legacy/YatRedirectForm';
import { useAppDispatch } from '@pkg/hooks';

import { setYatRedirectModalIsOpen } from '@app/store/actions/dashboard.ts';

export function RedirectSheet() {
    const dispatch = useAppDispatch();

    function handleClose() {
        dispatch(setYatRedirectModalIsOpen(false));
    }

    return (
        <Sheet backdrop gapless onClose={handleClose}>
            <Sheet.FixedCloseAction key="CloseAction" onAction={handleClose} />

            <Sheet.Main>
                <Sheet.Main.SoloSection gutters padded>
                    <YatRedirectForm closeForm={handleClose} />
                </Sheet.Main.SoloSection>
            </Sheet.Main>
        </Sheet>
    );
}
